import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';

export type Session = {
  _id: string;
  userAgent: string | null;
  createdAt: string;
};

export type GetSessionsResponse = {
  sessions: Session[];
};

const getSessions = async (): Promise<GetSessionsResponse> => {
  const { data } = await customAxios.get<GetSessionsResponse>('/sessions');
  return data;
};

export const useGetSessions = (): UseQueryResult<GetSessionsResponse> =>
  useQuery({
    queryKey: ['sessions'],
    queryFn: getSessions,
  });
